import { object, string } from "yup";

const email = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

const registrationSchema = (localization) => object({
  first_name: string().required(localization.fields.first_name.errors.required),
  last_name: string().required(localization.fields.last_name.errors.required),
  email: string()
    .required(localization.fields.email.errors.required)
    .matches(email, localization.fields.email.errors.invalid),
  password: string()
    .required(localization.fields.password.errors.required)
    .min(8, localization.fields.password.errors.min_length),
  country: string().required(localization.fields.country.errors.required),
  state: string().required(localization.fields.state.errors.required),
  city: string().required(localization.fields.city.errors.required),
}).required();

export default registrationSchema;